import React from 'react';

export const FilePDF = React.memo(() => (
  <>
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='linear-gradient-pdf'
        x1='6.65'
        x2='27.27'
        y1='6.65'
        y2='27.27'
      >
        <stop offset='0' stopColor='#ef6461' />
        <stop offset='1' stopColor='#e83d3d' />
      </linearGradient>
      <linearGradient
        x1='6'
        x2='12'
        y1='5'
        y2='5'
        id='linear-gradient-pdf-2'
        xlinkHref='#linear-gradient-pdf'
      />
    </defs>
    <path
      fill={'url(#linear-gradient-pdf)'}
      d='M23.5,2h-12a.47.47,0,0,0-.35.15l-5,5A.47.47,0,0,0,6,7.5v20A2.5,2.5,0,0,0,8.5,30h15A2.5,2.5,0,0,0,26,27.5V4.5A2.5,2.5,0,0,0,23.5,2Z'
    />
    <path
      fill={'url(#linear-gradient-pdf-2)'}
      d='M11.69,2a.47.47,0,0,0-.54.11l-5,5A.47.47,0,0,0,6,7.69.5.5,0,0,0,6.5,8h3A2.5,2.5,0,0,0,12,5.5v-3A.5.5,0,0,0,11.69,2Z'
    />
    <path
      fill={'#f8edeb'}
      d='M15.5,11h-1a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,.5.5h1A2.5,2.5,0,0,0,18,18.5v-5A2.5,2.5,0,0,0,15.5,11ZM17,18.5A1.5,1.5,0,0,1,15.5,20H15V12h.5A1.5,1.5,0,0,1,17,13.5Z'
    />
    <path
      fill={'#f8edeb'}
      d='M11.5,11h-2a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,1,0V17h1.5A1.5,1.5,0,0,0,13,15.5v-3A1.5,1.5,0,0,0,11.5,11Zm.5,4.5a.5.5,0,0,1-.5.5H10V12h1.5a.5.5,0,0,1,.5.5Z'
    />
    <path
      fill={'#f8edeb'}
      d='M22.5,15H20V12h2.5a.5.5,0,0,0,0-1h-3a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,1,0V16h2.5a.5.5,0,0,0,0-1Z'
    />
  </>
));
FilePDF.displayName = 'FilePDF';
